module.exports = __webpack_public_path__ + "assets/images/profiles/2020-main-6-desktop.jpg?v=90f2767d";